import React from 'react'
import {ProposalToolDashboard} from '../Dashboard/ProposalToolDashboard'
import {
  ContentArea,
  PageHeader,
  PageWrapper,
} from '../../ProposalMain/ProposalMain.styles'
import {
  HeaderContainer,
  LeftBlock,
  PageTitle,
  TitleBold,
} from '../../components/ProposalHeader/styled.components'

// Same stats/filters/table UI as the Proposal Tool's own dashboard, but
// scoped to every rep's proposals (allReps) and view-only (readOnly).
function ProposalMetrics() {
  return (
    <PageWrapper data-theme="ooe-v1">
      <PageHeader>
        <HeaderContainer>
          <LeftBlock>
            <PageTitle>
              <TitleBold>Proposal Metrics</TitleBold>
            </PageTitle>
          </LeftBlock>
        </HeaderContainer>
      </PageHeader>
      <ContentArea>
        <ProposalToolDashboard allReps readOnly />
      </ContentArea>
    </PageWrapper>
  )
}

export {ProposalMetrics}
